// extracted by mini-css-extract-plugin
export default {"or":"styles-module__or__src-labstep-web-screens-Error-VerifyEmail-_eveD2"};